import React from "react";

const MAIL = "mailto:info@duaura.ai";
const svc = (l) => [l, "#services"];
const cols = [
  {
    title: "Services",
    links: ["AI Chatbots", "Workflow Automation", "Outreach Systems", "Data Pipelines", "Analytics"].map(svc),
  },
  {
    title: "Company",
    links: [["About", "#about"], ["Process", "#process"], ["Contact", MAIL]],
  },
  {
    title: "Connect",
    links: [["Book a call", "#book"], ["Email", MAIL]],
  },
];

export default function Footer() {
  return (
    <footer id="contact" className="relative bg-[var(--night)] text-white pt-16 pb-8">
      <div className="max-w-[1240px] mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-12 pb-14 border-b border-white/10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="relative w-9 h-9 rounded-full overflow-hidden flex items-center justify-center bg-[var(--porcelain-mist)] ring-1 ring-[var(--camel)]/50">
                <img
                  src="/duaura-logo.png"
                  alt="Duaura"
                  className="w-full h-full object-contain p-1"
                />
              </span>
              <span className="font-serif text-[24px] text-white">Duaura</span>
            </div>
            <p className="mt-6 text-[15px] leading-[1.65] text-white/65 max-w-[420px]">
              Custom automation systems for growing service businesses. We design,
              deploy, and refine the AI infrastructure that runs your operations.
            </p>
            <div className="mt-7 inline-flex items-center gap-2 font-mono text-[10.5px] tracking-[0.22em] uppercase text-white/45">
              <span className="w-1.5 h-1.5 rounded-full bg-[var(--blue)]" />
              St. Petersburg · Florida
            </div>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-3 gap-8">
            {cols.map((c, i) => (
              <div key={i}>
                <div className="font-mono text-[10.5px] tracking-[0.22em] uppercase text-white/40 mb-5">
                  {c.title}
                </div>
                <ul className="space-y-3">
                  {c.links.map(([l, href], j) => (
                    <li key={j}>
                      <a
                        href={href}
                        data-testid={`footer-link-${l.toLowerCase().replace(/\s+/g, "-")}-${i}`}
                        className="text-[14px] text-white/75 hover:text-white link-shimmer"
                      >
                        {l}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-[12px] text-white/45">
            © {new Date().getFullYear()} Duaura. All rights reserved.
          </p>
          <p className="font-mono text-[10.5px] tracking-[0.22em] uppercase text-white/40">
            Built with intent · For ambitious operators
          </p>
        </div>
      </div>

      {/* Oversized wordmark */}
      <div className="select-none pointer-events-none mt-10 overflow-hidden">
        <div className="font-serif text-[20vw] sm:text-[18vw] leading-[0.85] text-white/[0.03] text-center -mb-[4vw]">
          DUAURA
        </div>
      </div>
    </footer>
  );
}
